
      var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 19.59,
  height: 19.546,
  viewBox: "0 0 19.59 19.546"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icons-phone_d120893ff81014bb__a",
  x1: 0.764,
  x2: 0.327,
  y1: 0.911,
  y2: 0.036,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#icons-phone_d120893ff81014bb__a)",
  d: "m19.07 14.163-2.721-2.651a2.22 2.22 0 0 0-2.86-.233 1.015 1.015 0 0 0-.163.116l-1.093 1.093a14 14 0 0 1-4.907-4.907l.744-.744a2.668 2.668 0 0 0 .837-1.767 2.441 2.441 0 0 0-.814-1.884L5.419.535A.4.4 0 0 0 5.3.442a2.463 2.463 0 0 0-3.046.21A6.374 6.374 0 0 0 .349 6.72a7.683 7.683 0 0 0 .86 2.674 22.6 22.6 0 0 0 5.442 6.558 16.367 16.367 0 0 0 7.256 3.512 4.761 4.761 0 0 0 .953.093 5.347 5.347 0 0 0 4.093-1.814 2.411 2.411 0 0 0 .814-1.465 2.572 2.572 0 0 0-.65-2 .136.136 0 0 0-.047-.116zm-1.3 2.14a.84.84 0 0 0-.162.139 3.635 3.635 0 0 1-3.326 1.186.088.088 0 0 1-.07-.023 14.921 14.921 0 0 1-6.325-3.093C2.465 9.767 2.209 6.6 2.209 6.535a.517.517 0 0 0-.023-.186 4.489 4.489 0 0 1 1.28-4.326.594.594 0 0 1 .72-.116l2.605 2.581a.717.717 0 0 1 .256.489.79.79 0 0 1-.233.465l-.047.046-1.232 1.256a.918.918 0 0 0-.186 1.047c1.86 4.209 6.418 6.581 6.6 6.7a.918.918 0 0 0 1.07-.162l1.535-1.489c.186-.093.349-.116.442-.023l.047.046 2.674 2.6c.186.233.372.582.046.837z",
  transform: "translate(-.199 -.011)"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"19.59\" height=\"19.546\" viewBox=\"0 0 19.59 19.546\">\r\n    <defs>\r\n        <linearGradient id=\"e7i61tw62a\" x1=\".764\" x2=\".327\" y1=\".911\" y2=\".036\" gradientUnits=\"objectBoundingBox\">\r\n            <stop offset=\"0\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n            <stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n        </linearGradient>\r\n    </defs>\r\n    <g>\r\n        <g>\r\n            <g>\r\n                <g>\r\n                    <g>\r\n                        <path fill=\"url(#e7i61tw62a)\" d=\"M19.07 14.163l-2.721-2.651a2.22 2.22 0 0 0-2.86-.233 1.015 1.015 0 0 0-.163.116l-1.093 1.093a14 14 0 0 1-4.907-4.907l.744-.744a2.668 2.668 0 0 0 .837-1.767 2.441 2.441 0 0 0-.814-1.884L5.419.535A.4.4 0 0 0 5.3.442a2.463 2.463 0 0 0-3.046.21A6.374 6.374 0 0 0 .349 6.72a7.683 7.683 0 0 0 .86 2.674 22.6 22.6 0 0 0 5.442 6.558 16.367 16.367 0 0 0 7.256 3.512 4.761 4.761 0 0 0 .953.093 5.347 5.347 0 0 0 4.093-1.814 2.411 2.411 0 0 0 .814-1.465 2.572 2.572 0 0 0-.65-2 .136.136 0 0 0-.047-.116zm-1.3 2.14a.84.84 0 0 0-.162.139 3.635 3.635 0 0 1-3.326 1.186.088.088 0 0 1-.07-.023 14.921 14.921 0 0 1-6.325-3.093C2.465 9.767 2.209 6.6 2.209 6.535a.517.517 0 0 0-.023-.186 4.489 4.489 0 0 1 1.28-4.326.594.594 0 0 1 .72-.116l2.605 2.581a.717.717 0 0 1 .256.489.79.79 0 0 1-.233.465l-.047.046-1.232 1.256a.918.918 0 0 0-.186 1.047c1.86 4.209 6.418 6.581 6.6 6.7a.918.918 0 0 0 1.07-.162l1.535-1.489c.186-.093.349-.116.442-.023l.047.046 2.674 2.6c.186.233.372.582.046.837z\" transform=\"translate(-.199 -.011)\"/>\r\n                    </g>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-phone.d120893ff81014bb99541281e44369a2.svg"),
        {
          React: SvgIconsPhone,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      